"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImageSize = void 0;
const constants_1 = require("./constants");
const getImageSize = (url, options = {}) => {
    return new Promise((resolve, reject) => {
        if (typeof window === 'undefined') {
            return reject(constants_1.ErrorMessage.WINDOW_IS_NOT_DEFINED);
        }
        if (!url) {
            return reject(constants_1.ErrorMessage.URL_IS_NOT_DEFINED);
        }
        let timer = null;
        const img = new Image();
        img.addEventListener('load', () => {
            if (timer) {
                window.clearTimeout(timer);
            }
            resolve({ width: img.naturalWidth, height: img.naturalHeight });
        });
        img.addEventListener('error', (event) => {
            if (timer) {
                window.clearTimeout(timer);
            }
            reject(`${event.type}: ${event.message}`);
        });
        img.src = url;
        if (options.timeout) {
            timer = window.setTimeout(() => reject(constants_1.ErrorMessage.TIMEOUT), options.timeout);
        }
    });
};
exports.getImageSize = getImageSize;
